module.exports = "<ng-container *ngIf=\"tutorialLink\">\n  <div class=\"watch-tutorial\">\n    <button type=\"button\" class=\"btn btn-blue\" *ngIf=\"tutorialLink\" (click)=\"watchTutorial(tutorialLink)\">View Tutorial</button>\n  </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/watch-tutorial/watch-tutorial.component.html
// module id = ../../../../../src/app/mnt-master/watch-tutorial/watch-tutorial.component.html
// module chunks = main